import * as tslib_1 from "tslib";
import api from '../api';
import { Note } from 'src/models/Note';
var resource = 'api/task/notes/';
var TaskNoteApi = /** @class */ (function () {
    function TaskNoteApi() {
    }
    TaskNoteApi.create = function (note) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.put(resource, note)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, new Note(data)];
                }
            });
        });
    };
    TaskNoteApi.update = function (id, note) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.post(resource + id, note)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status !== 500 && response.status !== 404];
                }
            });
        });
    };
    TaskNoteApi.delete = function (id) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.delete(resource + id)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.status !== 500 && response.status !== 404];
                }
            });
        });
    };
    return TaskNoteApi;
}());
export default TaskNoteApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/TaskNoteApi.ts
// module id = 348
// module chunks = 0